// extracted by mini-css-extract-plugin
export default {"blog":"styles_blog__G2FIc","blog__link":"styles_blog__link__yg8ey","item":"styles_item__hh9rC","item__in":"styles_item__in__7L4F7"};